var $ = require('../internals/export');
var global = require('../internals/global');

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.global-this.js
// module id = 479
// module chunks = 0